import { List } from "@remo-co/ui-core/src/components/List";
import { ListItem } from "@remo-co/ui-core/src/components/ListItem";
import { ListItemText } from "@remo-co/ui-core/src/components/ListItemText";
import { Popover } from "@remo-co/ui-core/src/components/Popover";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { InfoRounded } from "@remo-co/ui-core/src/icons/InfoRounded";
import { useI18n } from "i18n";
import { useStyles, styles } from "./SsoHelperDialogStyles";

interface ISsoHelperDialogProps {
  anchorEl: HTMLElement | null;
  handlePopoverClose: () => void;
}

const FieldNames = () => {
  const { t } = useI18n(["sso"]);

  return (
    <Typography>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span>name</span>, <span>firstName</span>, <span>lastName</span>,{" "}
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span>picture</span>, <span>headline</span>, <span>company</span>{" "}
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span>{t("or.text")}</span> <span>organization</span>, <span>title</span>{" "}
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span>{t("or.text")}</span> <span>jobTitle</span>,{" "}
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span>meetingLink</span>, <span>facebook</span>, <span>linkedin</span>,{" "}
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span>website</span>
    </Typography>
  );
};

const SsoHelperDialog = ({
  anchorEl,
  handlePopoverClose,
}: ISsoHelperDialogProps) => {
  const open = Boolean(anchorEl);
  const { t } = useI18n(["sso"]);
  const classes = useStyles();

  return (
    <Popover
      data-testid="sso-helper-dialog"
      classes={{ paper: classes.paper }}
      open={open}
      anchorEl={anchorEl}
      transformOrigin={{ vertical: 12, horizontal: 15 }}
      onClose={handlePopoverClose}
      disableRestoreFocus
      PaperProps={{ elevation: 1 }}
    >
      <Box sx={styles.title}>
        <InfoRounded color="primary" />
        <Typography variant="h5">{t("helper.popup.pretitle")}</Typography>
      </Box>
      <Typography variant="h5">{t("helper.popup.title")}</Typography>
      <List sx={styles.list}>
        <ListItem>
          <ListItemText>{t("helper.popup.bullet.1")}</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            {t("helper.popup.bullet.2")}{" "}
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <Typography>format:urn:oasis:names:tc:SAML:1.1:nameid-</Typography>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>{t("helper.popup.bullet.3")}</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>{t("helper.popup.bullet.4")}</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>{t("helper.popup.bullet.5")}</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>{t("helper.popup.bullet.6")}</ListItemText>
        </ListItem>
      </List>
      <Box sx={styles.fieldInfo}>
        <Typography variant="h5">{t("helper.fields.title")}</Typography>
        <Typography>
          <FieldNames />
        </Typography>
      </Box>
    </Popover>
  );
};

export default SsoHelperDialog;
